import type { UseTooltipParams } from '@visx/tooltip/lib/hooks/useTooltip';
import { AnimatePresence } from 'motion/react';
import Tooltip from '@/components/Charts/ui/Tooltip';
import type { Data, Margin } from '@/types/chart';

export const ChartTooltip = <T extends Data>({
  unit,
  chartMargins,
  innerHeight,
  accessor,
  tooltipOpen,
  tooltipData,
  tooltipTop,
  tooltipLeft,
}: {
  unit: string;
  chartMargins: Margin;
  innerHeight: number;
  accessor: {
    getValue: (d: Data) => number;
    getDate: (d: Data) => Date;
  };
} & UseTooltipParams<{ data: T }>) => {
  return (
    <AnimatePresence>
      {tooltipData && tooltipOpen && (
        <Tooltip
          innerHeight={innerHeight}
          margin={chartMargins}
          tooltipTop={tooltipTop}
          tooltipLeft={tooltipLeft}
          tooltipData={tooltipData}
          accessor={accessor}
          unit={unit}
        />
      )}
    </AnimatePresence>
  );
};
